import { render, staticRenderFns } from "./HomeMessage.vue?vue&type=template&id=f1cec33a&scoped=true&"
import script from "./HomeMessage.vue?vue&type=script&lang=js&"
export * from "./HomeMessage.vue?vue&type=script&lang=js&"
import style0 from "./HomeMessage.vue?vue&type=style&index=0&id=f1cec33a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1cec33a",
  null
  
)

export default component.exports